import styled, { css } from 'styled-components';

import { Theme } from '@develop-fapp/ui-kit-fapp';

export const Label = styled.label`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    position: relative;

    > input {
      background-color: ${theme.colors.white};
      border-radius: ${Theme.border.radius.md};
      border: 1px solid ${theme.colors.grey5};
      color: ${theme.colors.grey3};
      font-family: ${Theme.typography.fontFamily.sansSerif};
      font-size: ${Theme.typography.heading.h7};
      font-weight: ${Theme.typography.weight.medium};
      padding: 10px 12px;
      position: relative;
      transition: 0.2s ease-in-out;
      width: 100%;

      &::placeholder {
        color: ${theme.colors.grey3};
        font-weight: ${Theme.typography.weight.light};
        width: max-content;
      }

      &:focus {
        outline: transparent;
      }
    }

    > div {
      -moz-box-shadow: 0px 18px 11px -9px rgb(0 0 0 / 30%);
      -webkit-box-shadow: 0px 18px 11px -9px rgb(0 0 0 / 30%);
      box-shadow: 0px 18px 11px -9px rgb(0 0 0 / 30%);
      display: initial;
      height: auto;
      margin-top: 52px;
      max-height: 100vh;
      overflow: auto;
      position: absolute;
      width: 100%;
      z-index: 100;

      > div {
        > div {
          align-items: stretch;
          background-color: ${theme.colors.white};
          border-bottom: 1px solid #f7f7f7;
          cursor: pointer;
          display: flex;
          justify-content: flex-start;
          padding: 8px 12px;
          text-align: left;
          z-index: 100;

          svg {
            fill: ${theme.colors.grey3};
            height: 1.5rem;
            margin-right: 10px;
            transition: 180ms ease-in-out;
          }

          > div {
            flex-direction: column;

            > span {
              color: ${theme.colors.grey1};
              font-size: ${Theme.typography.heading.h7};
              font-weight: ${Theme.typography.weight.semibold};
            }
            > p {
              color: ${theme.colors.grey3};
              font-size: ${Theme.typography.heading.h8};
              font-weight: ${Theme.typography.weight.medium};
              margin: 5px 0 15px;
            }
          }
        }
      }
    }
  `}
`;
